import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const StyledHomeBanner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem ${themeGet('scale.scaleUp05')};
  font-size: ${themeGet('scale.scaleDown01')};
  text-align: center;
  color: ${themeGet('color.colorWhite')};
  background: #0E3D88;
  overflow: hidden;
  font-weight: bold;
  font-size: 0.75rem;

  .btn--primary {
    display: none;
    padding: 0.1rem 0.3rem;
    border-radius: 3px;
    font-size: 0.8rem;
  }

  p {
    position: relative;
    margin: 0;
    font-size: ${themeGet('scale.scaleDown02')};
    line-height: 1.33;

    @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
      font-size: 15px;
    }
  }

  a {
    font-family: inherit;
    color: inherit;
    text-decoration: none;
    height: 100%;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    font-size: 1rem;
    flex-direction: row;

    .btn--primary {
      display: block;
      margin-left: 0.5rem;
    }
  }
`;

export default StyledHomeBanner;
